export interface Module {
  number: number
  title: string
  body: string
  tagline: string
  color: string
}

export const modules: Module[] = [
  {
    number: 1,
    title: 'DIESEL DIAGNOSTIC FOUNDATIONS & TROUBLESHOOTING WORKFLOW',
    body: 'Follow a structured diesel diagnostic process from initial symptom to root cause. Use preliminary inspections, DTC analysis, live data, testing sequences and decision paths to determine what to check next.',
    tagline: 'Verify. Test. Isolate.',
    color: '#2A3441',
  },
  {
    number: 2,
    title: 'FUEL SYSTEM & COMMON RAIL DIAGNOSTICS',
    body: 'Troubleshoot fuel supply, pressure, common rail, pump and injector-related problems. Work through low-pressure supply, rail pressure, injector return, contamination and fuel-system diagnostic paths.',
    tagline: 'Measure. Compare. Diagnose.',
    color: '#C0392B',
  },
  {
    number: 3,
    title: 'AIR INTAKE, TURBO & BOOST DIAGNOSTICS',
    body: 'Find airflow, turbocharger and boost faults with structured diagnostic tests. Work through intake restrictions, charge-air leaks, MAF/MAP, intercooler, VGT, actuators and boost-control problems.',
    tagline: 'Inspect. Test. Verify.',
    color: '#E1701A',
  },
  {
    number: 4,
    title: 'ELECTRICAL, SENSOR & ELECTRONIC DIAGNOSTICS',
    body: 'Turn electrical symptoms, sensor data and trouble codes into clearer diagnostic decisions. Use circuit testing, voltage-drop checks, sensor analysis, actuator testing and scan-tool diagnostic strategies.',
    tagline: 'Scan. Measure. Test.',
    color: '#1B6CA8',
  },
  {
    number: 5,
    title: 'EGR, DPF, SCR & EMISSIONS DIAGNOSTICS',
    body: 'Troubleshoot modern diesel emissions and aftertreatment problems. Work through EGR, DPF restriction, regeneration, exhaust-temperature sensors, SCR, DEF and NOx-related diagnostic paths.',
    tagline: 'Check. Compare. Diagnose.',
    color: '#2E7D46',
  },
  {
    number: 6,
    title: 'ADVANCED DIESEL FAULT DIAGNOSIS & REAL-WORLD CASES',
    body: 'Start directly from common diesel symptoms and diagnostic evidence. Work through no-starts, hard starting, low power, rough idle, excessive smoke, overheating, limp mode and intermittent faults.',
    tagline: 'Identify. Isolate. Confirm.',
    color: '#6B3FA0',
  },
]

export interface Bonus {
  number: number
  title: string
  subtitle: string
  body: string
  tagline: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'DIESEL QUICK DIAGNOSTIC CHECKLISTS™',
    subtitle: 'Ready-to-Use Diesel Inspection & Troubleshooting Checklists',
    body: 'Follow organized checklists for no-starts, hard starting, low power, smoke, boost faults, DPF problems and other common diesel complaints.',
    tagline: 'Check. Follow. Diagnose.',
  },
  {
    number: 2,
    title: 'DIESEL DTC & LIVE DATA FIELD GUIDE™',
    subtitle: 'A Practical DTC & Scan-Data Reference',
    body: 'Organize trouble codes, freeze-frame information and live data to compare commanded and actual values and identify the next relevant diagnostic test.',
    tagline: 'Scan. Compare. Test.',
  },
  {
    number: 3,
    title: 'DIESEL TEST VALUES & MEASUREMENT WORKSHEETS™',
    subtitle: 'Professional Ready-to-Use Diagnostic Worksheets',
    body: 'Record electrical, fuel, injector, boost and aftertreatment measurements and compare actual test results with the correct specifications.',
    tagline: 'Measure. Record. Compare.',
  },
  {
    number: 4,
    title: 'DIESEL SYMPTOM-TO-CAUSE TROUBLESHOOTING MATRIX™',
    subtitle: 'A Practical Diesel Fault-Finding Reference',
    body: 'Start with the symptom and identify the systems and possible causes that should be tested for no-starts, smoke, low power, boost and emissions problems.',
    tagline: 'Find. Follow. Isolate.',
  },
  {
    number: 5,
    title: 'DIESEL DIAGNOSTIC JOB SHEETS & CASE REPORT SYSTEM™',
    subtitle: 'Ready-to-Use Diagnostic Documentation Tools',
    body: 'Document complaints, diagnostic evidence, test results, root causes, repairs and post-repair verification with structured professional job sheets.',
    tagline: 'Diagnose. Verify. Document.',
  },
]
